import { Paper } from '@mui/material';
import React from 'react';
import { themeColors } from '../JuvareTheme';
import { gradients } from './colors';
export const ColorPaper = (props) => {
    const { gradient, className, sx, children } = props;
    return (React.createElement(Paper, { elevation: 0, sx: [
            Object.assign(Object.assign({}, gradients[gradient]), { color: themeColors.decorative.white, borderRadius: 0 }),
            ...(Array.isArray(sx) ? sx : [sx]),
        ], className: className, "data-test": 'color-paper', "data-color": gradient }, children));
};
